export const preloaderConfig = {
  slideUpDelay: 2000, // Time in milliseconds before slide-up animation starts
  slideUpDuration: 1000, // Duration of the slide-up animation
  fadeInDuration: 4000, // Duration of the fade-in animation for first image
  secondImageDelay: 1000, // Delay before second image appears
};